/* eslint-disable */
import 'leaflet/dist/leaflet.css'
import exif from 'exif-js'
import leaflet from 'leaflet'

var geolocationDefaults = {
  geolocation: true,
  map: null,
  mapElement: null,
  noGeolocationIcon: null,
  marker: null,
  active: false,
};

var Geolocation = function(element) {

  this.el = element;

  this.core = window.lgData[this.el.getAttribute('lg-uid')];
  this.core.s = Object.assign({}, geolocationDefaults, this.core.s);

  this.init();

  return this;
};

Geolocation.prototype.init = function() {
  if (this.core.s.geolocation) {
    var geolocationButton = '<span class="lg-geolocation lg-icon"></span>';
    this.core.outer.querySelector('.lg-toolbar').insertAdjacentHTML('beforeend', geolocationButton);

    var geolocationMap = '<div id="lg-map" class="lg-map"></span>';
    this.core.outer.querySelector('.lg').insertAdjacentHTML('beforeend', geolocationMap);

    var noGeolocation = '<img class="lg-no-geolocation" src="/static/icons/location-off.png"/>';
    this.core.outer.querySelector('.lg').insertAdjacentHTML('beforeend', noGeolocation);

    this.geolocation();
  }
};

Geolocation.prototype.geolocation = function() {
  var _this = this;

  delete leaflet.Icon.Default.prototype._getIconUrl;
  leaflet.Icon.Default.mergeOptions({  
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),  
    iconUrl: require('leaflet/dist/images/marker-icon.png'),  
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')  
  });

  this.core.s.map = leaflet.map('lg-map');
  leaflet.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png').addTo(this.core.s.map);
  this.core.s.mapElement = this.core.outer.querySelector('.lg-map');
  this.core.s.noGeolocationIcon = this.core.outer.querySelector('.lg .lg-no-geolocation');

  utils.on(this.core.el, 'onSlideItemLoad.lg', function(event) {
    var index = event.detail.index;
    var image = _this.core.___slide[index].querySelector('.lg-image');
    if (image) {
      exif.getData(image, function() {
        if (this.exifdata && this.exifdata.GPSLatitude && this.exifdata.GPSLongitude) {
          image.setAttribute("data-latitude", _this.toDecimal(this.exifdata.GPSLatitude));
          image.setAttribute("data-longitude", _this.toDecimal(this.exifdata.GPSLongitude));
        }
      });
    }
  });

  utils.on(this.core.outer.querySelector('.lg-geolocation'), 'click.lg', function() {
    if (_this.core.s.active) {
      var image = _this.core.outer.querySelector('.lg-current .lg-image');
      image.style.opacity = "1";
      _this.core.s.mapElement.style.opacity = "0";
      _this.core.s.mapElement.style.zIndex = "1";
      _this.core.s.active = false;
    } else {
      var image = _this.core.outer.querySelector('.lg-current .lg-image');
      var latitude = null;
      var longitude = null;
      
      if (image) {
        latitude = image.getAttribute("data-latitude");
        longitude = image.getAttribute("data-longitude");
      }
      
      if (latitude && longitude) {
        if (!_this.core.s.marker) {
          _this.core.s.map.setView([latitude, longitude], 17);
          _this.core.s.marker = leaflet.marker([latitude, longitude]).addTo(_this.core.s.map); 
        }
        image.style.opacity = "0";
        _this.core.s.mapElement.style.zIndex = "1079";
        _this.core.s.mapElement.style.opacity = "1";
        _this.core.s.active = true;
      } else {
        if (_this.core.s.noGeolocationIcon.style.display === "block") {
          _this.core.s.noGeolocationIcon.style.display = "none";
        } else {
          _this.core.s.noGeolocationIcon.style.display = "block";
        }
      }
    }
  });

  utils.on(this.core.el, 'onBeforeSlide.lg', function(event) {
    if (_this.core.s.active) {
      _this.core.s.mapElement.style.opacity = "0";
      _this.core.s.mapElement.style.zIndex = "0";
      _this.core.s.active = false;
      _this.core.s.map.removeLayer(_this.core.s.marker);
      _this.core.s.marker = null;
    }
    _this.core.s.noGeolocationIcon.style.display = "none";
  });
};

Geolocation.prototype.toDecimal = function(number) {
  return number[0].numerator + number[1].numerator /
    (60 * number[1].denominator) + number[2].numerator / (3600 * number[2].denominator);
};

Geolocation.prototype.destroy = function() {
  if (this.core.s.map) {
    this.core.s.map.remove();
  }
  this.core.s.map = null;
  utils.off(this.core.el, 'onSlideItemLoad.lg');
};

window.lgModules.geolocation = Geolocation;


// WEBPACK FOOTER //
// ./src/components/utils/MediaViewer/lg-geolocation/index.js